import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import SearchIcon from '@mui/icons-material/Search';

import Loading from '../../common/Loading';
import LoadListDetailsOwnershipContractToLookup from './LoadListDetailsOwnershipContractToLookup';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListDetailsOwnershipContractToDisplay(props) {
    console.debug('RTS Break LoadListDetailsOwnershipContractToDisplay');

    const {sessionCustomer} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);

    const [showContractToModal, setShowContractToModal] = useState(false);
    const [assignedToLink, setAssignedToLink] = useState();
    const [contractToLink, setContractToLink] = useState();


    useEffect(() => {
        setAssignedToLink(props.data.assignedToLink);
        setContractToLink(props.contractToLink);
        setIsLoading(false);
    }, [props.data]); 


    function getContractToLinkDisplay(){
        if(contractToLink != null && assignedToLink != null && assignedToLink.linkCustomerIdGuid == sessionCustomer.customer.idGuid){
            if(contractToLink.linkCustomer!=null){
                 return contractToLink.name + " (" + contractToLink.linkCustomer.idSap + ")";
            }
            else{
                return contractToLink.name;
            }

        }
        else{
            return '';
        }
    }


    function setContractToLinkVal(pVal){
        props.setContractToLinkFx(pVal);
        setContractToLink(pVal);
        setShowContractToModal(false);
        props.setFormDirtyFx(1);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    if(assignedToLink != null && assignedToLink.linkCustomerIdGuid == sessionCustomer.customer.idGuid){
        return (
            <>
            <Dialog fullWidth={true} maxWidth="md" open={showContractToModal} onClose={()=>{setShowContractToModal(false);}}>
                <DialogTitle>Contract To</DialogTitle>
                <DialogContent>
                    <Box>
                        <LoadListDetailsOwnershipContractToLookup contractToLink={contractToLink} setContractToLinkFx={setContractToLinkVal} />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowContractToModal(false);}} sx={{mr:2}}>Close</Button>
                </DialogActions>
            </Dialog> 
            <Box id="ContractToLink" sx={{display:'flex', alignItems:'center'}}>
                <TextField
                    id="tbContractTo"
                    margin="normal"
                    fullWidth
                    label="Contract To"
                    size="small"
                    value={getContractToLinkDisplay()}
                    onClick={setShowContractToModal}
                />
                <Box sx={{ml:1, mt:1}}>            
                    <Button variant="contained" onClick={setShowContractToModal}>
                        <SearchIcon sx={{fontSize:'2em'}} />
                    </Button>
                </Box>            
            </Box>
            </>
        );
    }
    else{
        return(
            <Box id="ContractToLinkDis" sx={{display:'flex', alignItems:'center'}}>
                <TextField
                    id="tbContractToDis"
                    margin="normal"
                    fullWidth
                    label="Contract To"
                    size="small"
                    value={getContractToLinkDisplay()}
                    disabled={true}
                />
            </Box>
        )
    }

}
